/*体检预约*/
const AssociationManage = r =>require.ensure([], () => r(require('./')), 'AssociationManage')
/*医院列表*/
const HospitalList = r =>require.ensure([], () => r(require('./hospital-list')), 'HospitalList')
/*合作单位*/
const CooperationUnit = r =>require.ensure([], () => r(require('./cooperation-unit')), 'CooperationUnit')
/*合作单位详情*/
const CooperationUnitInfo = r =>require.ensure([], () => r(require('./cooperation-unit/info')), 'CooperationUnitInfo')
/*行业行动*/
const IndustryAction = r =>require.ensure([], () => r(require('./industry-action')), 'IndustryAction')
/*行业行动详情*/
const IndustryActionInfo = r =>require.ensure([], () => r(require('./industry-action/info')), 'IndustryActionInfo')
/*学组介绍*/
const GroupIntroduction = r =>require.ensure([], () => r(require('./group-introduction')), 'GroupIntroduction')
/*学组详情*/
const GroupIntroductionInfo = r =>require.ensure([], () => r(require('./group-introduction/info')), 'GroupIntroductionInfo')
/*吃出健康*/
const EatHealthy = r =>require.ensure([], () => r(require('./eat-healthy')), 'EatHealthy')
/*吃出健康列表*/
const EatHealthyList = r =>require.ensure([], () => r(require('./eat-healthy/list')), 'EatHealthyList')
/*吃出健康详情*/
const EatHealthyInfo = r =>require.ensure([], () => r(require('./eat-healthy/info')), 'EatHealthyInfo')
/*节气养生*/
const SolarHealth = r =>require.ensure([], () => r(require('./solar-health')), 'SolarHealth')
/*四季养生*/
const FourSeasons = r =>require.ensure([], () => r(require('./four-seasons')), 'FourSeasons')

export default {
  path:'/association-manage',
  component: AssociationManage,
  meta: { title: '选择医院' },
  redirect: '/user/login',
  children: [
    {
      path:'hospital-list',
      component: HospitalList,
      meta: { title: '公立医院' }
    },
    {
      path:'cooperation-unit',
      component: CooperationUnit,
      meta: { title: '合作单位' }
    },
    {
      path:'/association-manage/cooperation-unit/info',
      component: CooperationUnitInfo,
      meta: { title: '合作单位详情' }
    },
    {
      path:'industry-action',
      component: IndustryAction,
      meta: { title: '行业行动' }
    },
    {
      path:'/association-manage/industry-action/info/:id',
      component: IndustryActionInfo,
      meta: { title: '行业行动详情' }
    },
    {
      path:'group-introduction',
      component: GroupIntroduction,
      meta: { title: '学组介绍' }
    },
    {
      path: '/association-manage/group-introduction/info/:id',
      meta: { title: '学组详情' },
      component: GroupIntroductionInfo
    },
    {
      path:'eat-healthy',
      component: EatHealthy,
      meta: { title: '吃出健康' }
    },
    {
      path:'/association-manage/eat-healthy/list/:id',
      component: EatHealthyList,
      meta: { title: '吃出健康列表' }
    },
    {
      path:'/association-manage/eat-healthy/info/:id',
      component: EatHealthyInfo,
      meta: { title: '吃出健康详情' }
    },
    {
      path:'solar-health',
      component: SolarHealth,
      meta: { title: '节气养生' }
    },
    {
      path:'four-seasons',
      component: FourSeasons,
      meta: { title: '四季养生' }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/association-manage/router.js